import axios, { AxiosResponse } from 'axios';
import { Notification } from '@/common/Notifications';

import { getSettings, getPublicSettings } from '@/services/Settings';

export interface INotification {
	setting_key: string;
	notification_message: string;
	visible: boolean;
}

interface VuexState {
	notifications: Notification[];
	notificationBanner: any;
}

const state: VuexState = {
	notifications: [],
	notificationBanner: {
		setting_key: 'notification',
		notification_message: '',
		visible: false,
	},
};

const getters = {
	notifications({ notifications }: VuexState) {
		return notifications.filter(notification => !notification.deleted);
	},
	getUnreadNotifications({ notifications }: VuexState) {
		return notifications.filter(
			notification =>
				!notification.deleted &&
				(notification.read_stamp === undefined || notification.read_stamp === ''),
		);
	},
};

const mutations = {
	setNotifications: (state: VuexState, notifications: Notification[]): void => {
		state.notifications = notifications;
	},
	setNotificationBanner: (state: VuexState, notificationBanner: any): void => {
		state.notificationBanner = notificationBanner;
	},
};

const actions = {
	async getNotifications({ commit }: any) {
		try {
			const { data }: AxiosResponse<Notification[]> = await axios({
				method: 'GET',
				url: process.env.VUE_APP_API_URI3 + '/notifications',
			});

			commit('setNotifications', data);
		} catch (e) {
			throw new Error('Error receiving the notifications');
		}
	},
	async postNotifications({ commit }: any, payload: any) {
		try {
			const { data }: AxiosResponse<Notification[]> = await axios({
				method: 'POST',
				url: process.env.VUE_APP_API_URI3 + '/notifications',
				data: payload,
			});

			commit('setNotifications', data);
		} catch (e) {
			throw new Error('Error updating the notifications');
		}
	},
	async getNotificationsBanner({ commit }: any, payload: any) {
		const { data } = await getPublicSettings(['notification']);

		commit(
			'setNotificationBanner',
			data.find((s: INotification) => s.setting_key === 'notification'),
		);
	},
};

export { state, getters, mutations, actions };
